<template>
	<textarea
		v-model="model"
		:placeholder="placeholder"
		:rows="rows"
		:disabled="disabled"
		:class="cn(
			'flex w-full rounded-2xl border-0 bg-muted px-4 py-3 text-base text-foreground placeholder:text-muted-foreground outline-none focus:ring-2 focus:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50',
			props.class
		)"
		v-bind="$attrs"
	/>
</template>

<script setup lang="ts">
import { cn } from '../../../utils/cn';

const model = defineModel<string>({ default: '' });

const props = defineProps<{
	placeholder?: string;
	rows?: number;
	disabled?: boolean;
	class?: string;
}>();
</script>
